import { useEffect, useState } from 'react';
import { goi, LoiApi } from './api';
import type { Don } from './kieu';

/**
 * Ghi chú của khách cho giỏ này — thứ khách dặn mà không phải một dòng hàng:
 * "gói quà", "để lại tới chiều lấy", "hỏi màu 118 còn không". Lưu ở `Order.note`,
 * thu ngân thấy trên phiếu, admin thấy ở chi tiết đơn. Xoá = lưu chuỗi rỗng.
 */
export function HopGhiChu({ gio, dong, xong }: { gio: Don; dong: () => void; xong: () => void }) {
  const [chu, datChu] = useState(gio.ghi_chu ?? '');
  const [dangLam, datDangLam] = useState(false);
  const [loi, datLoi] = useState<string | null>(null);
  const daDoi = chu.trim() !== (gio.ghi_chu ?? '');

  useEffect(() => {
    const f = (e: KeyboardEvent) => {
      if (e.key === 'Escape') dong();
    };
    window.addEventListener('keydown', f);
    return () => window.removeEventListener('keydown', f);
  }, [dong]);

  const luu = async () => {
    if (dangLam) return;
    datDangLam(true);
    datLoi(null);
    try {
      await goi(`/api/gio/${gio.id}/ghi-chu`, { method: 'PATCH', than: { ghi_chu: chu.trim() } });
      xong();
    } catch (e) {
      datLoi(e instanceof LoiApi ? e.message : 'Không lưu được ghi chú.');
      datDangLam(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={dong}
      className="hien-mo"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(126, 120, 128, 0.46)',
        backdropFilter: 'blur(4px)',
        display: 'grid',
        placeItems: 'center',
        padding: 20,
        zIndex: 50,
      }}
    >
      <div
        className="noi phong-len"
        onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 420, padding: 26, boxShadow: 'var(--noi-to)' }}
      >
        <div style={{ fontSize: 21, fontWeight: 700, marginBottom: 4 }}>Ghi chú giỏ {gio.ma}</div>
        <div style={{ color: 'var(--chu-3)', fontSize: 'var(--chu-nho)', marginBottom: 14 }}>
          Khách dặn gì thêm — thu ngân sẽ thấy trên phiếu.
        </div>
        {loi && (
          <div role="alert" className="lom-nho" style={{ padding: '10px 14px', marginBottom: 12, color: 'var(--nhan-dam)', fontWeight: 600, fontSize: 'var(--chu-nho)' }}>
            {loi}
          </div>
        )}
        <textarea
          autoFocus
          value={chu}
          maxLength={2000}
          onChange={(e) => datChu(e.target.value)}
          placeholder="Ví dụ: gói quà, lấy hoá đơn đỏ, giữ tới 17h…"
        />
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button style={{ flex: 1, padding: 15 }} onClick={dong} disabled={dangLam}>
            Đóng
          </button>
          <button className="nut-chinh" style={{ flex: 1, padding: 15 }} onClick={() => void luu()} disabled={!daDoi || dangLam}>
            {dangLam ? 'Đang lưu…' : gio.ghi_chu && chu.trim() === '' ? 'XOÁ GHI CHÚ' : 'LƯU'}
          </button>
        </div>
      </div>
    </div>
  );
}
